import { Component } from '@angular/core';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {
  title = 'breadcrumb';
}



// WEBPACK FOOTER //
// ./src/app/layout/breadcrumb/breadcrumb.component.ts